<template>
  <div>
    <EvaluacionRespetoPrincipiosDialogComponent
      v-if="activeDialog === 'respetoPrincipios'"
      :active="activeDialog === 'respetoPrincipios'"
      @close="$emit('close')"
      :respeto-principios="evaluacion"
      :readonly="readonly"
    />
    <EvaluacionProductividadDialogComponent
      v-if="activeDialog === 'productividad'"
      :active="activeDialog === 'productividad'"
      @close="$emit('close')"
      :productividad="evaluacion"
      :readonly="readonly"
    />
    <EvaluacionDisciplinaOperativaDialogComponent
      v-if="activeDialog === 'disciplinaOperativa'"
      :active="activeDialog === 'disciplinaOperativa'"
      @close="$emit('close')"
      :disciplina-operativa="evaluacion"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import EvaluacionRespetoPrincipiosDialogComponent from '@/components/desarrollo_policial/EvaluacionRespetoPrincipiosDialogComponent.vue'
import EvaluacionProductividadDialogComponent from '@/components/desarrollo_policial/EvaluacionProductividadDialogComponent.vue'
import { mapActions } from 'vuex'
import EvaluacionDisciplinaOperativaDialogComponent from '@/components/desarrollo_policial/EvaluacionDisciplinaOperativaDialogComponent.vue'

export default {
  components: {
    EvaluacionRespetoPrincipiosDialogComponent,
    EvaluacionProductividadDialogComponent,
    EvaluacionDisciplinaOperativaDialogComponent,
  },

  props: {
    activeDialog: {
      type: String,
      default: '',
    },

    evaluacion: {
      type: Object,
      default: () => ({}),
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    await this.fetchFrecuenciaProductividad()
  },

  methods: {
    ...mapActions('frecuenciaProductividad', ['fetchFrecuenciaProductividad']),
  },
}
</script>
